import { render, staticRenderFns } from "./VendasPosPagas.vue?vue&type=template&id=09c29ff2&scoped=true"
import script from "./VendasPosPagas.vue?vue&type=script&lang=js"
export * from "./VendasPosPagas.vue?vue&type=script&lang=js"
import style0 from "./VendasPosPagas.vue?vue&type=style&index=0&id=09c29ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c29ff2",
  null
  
)

export default component.exports